
import api from '@/api/my/orders';
import { IOrder } from '@/types/models';
import { defineComponent } from 'vue';

interface IState {
  items: IOrder[];
}

export default defineComponent({
  data() {
    return {
      items: [],
    } as IState;
  },
  methods: {
    getResourceType(item: IOrder) {
      if (item.resourceType === 'Extension') return '插件';
      if (item.resourceType === 'Theme') return '模板';
      if (item.resourceType === 'Starter') return '网站云入门版';
      if (item.resourceType === 'Standard') return '网站云标准版';
      if (item.resourceType === 'Professional') return '网站云专业版';
      return '';
    },

    getChannel(item: IOrder) {
      if (item.channel === 'AliPay') return '支付宝';
      if (item.channel === 'WxPay') return '微信支付';
      return '';
    },

    isDownload(item: IOrder) {
      if (item.resourceType === 'Theme' || item.resourceType === 'Extension') {
        return true;
      }
      return false;
    },

    isUrl(item: IOrder) {
      if (item.resourceType === 'Theme' || item.resourceType === 'Extension') {
        return true;
      }
      return false;
    },

    getUrl(item: IOrder) {
      if (item.resourceType === 'Theme') {
        return `/templates/template.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Extension') {
        return `/plugins/plugin.html?resourceId=${item.resourceId}`;
      }
      return '#';
    },

    btnDownloadClick(item: IOrder) {
      api.download({
        resourceType: item.resourceType,
        resourceId: item.resourceId,
      }, (res) => {
        if (!res) return;
        window.open(res.value);
      });
    },
  },
  mounted() {
    api.getItems((res) => {
      if (!res) return;
      this.items = res.items;
    });
  },
});
